// Настройки стенда приходят в рантайме из env.js, см. app-env в common-module.
// Здесь остаётся только то, что определяется конфигурацией сборки.
export const environment = {
  production: false
};
